import React from 'react';
import Input from '../../../components/ui/Input';

const ContactDetailsTab = ({ formData, handleChange, errors, isEditing }) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="First Name"
          type="text"
          name="firstName"
          value={formData?.firstName}
          onChange={handleChange}
          placeholder="John"
          error={errors?.firstName}
          disabled={!isEditing}
          required
        />
        
        <Input
          label="Last Name"
          type="text"
          name="lastName"
          value={formData?.lastName}
          onChange={handleChange}
          placeholder="Doe"
          error={errors?.lastName}
          disabled={!isEditing}
          required
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Email Address"
          type="email"
          name="email"
          value={formData?.email}
          onChange={handleChange}
          placeholder="john.doe@example.com"
          error={errors?.email}
          disabled={!isEditing}
          required
          description="Primary contact email"
        />
        
        <Input
          label="Phone Number"
          type="tel"
          name="phone"
          value={formData?.phone}
          onChange={handleChange}
          placeholder="(555) 123-4567"
          error={errors?.phone}
          disabled={!isEditing}
          required
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Mobile Number"
          type="tel"
          name="mobile"
          value={formData?.mobile}
          onChange={handleChange}
          placeholder="(555) 987-6543"
          error={errors?.mobile}
          disabled={!isEditing}
          description="Optional mobile contact"
        />
        
        <Input
          label="Job Title"
          type="text"
          name="jobTitle"
          value={formData?.jobTitle}
          onChange={handleChange}
          placeholder="Partner Manager"
          error={errors?.jobTitle}
          disabled={!isEditing}
        />
      </div>
    </div>
  );
};

export default ContactDetailsTab;